import React from 'react'
import {TableRow, TableCell, Typography} from '@material-ui/core'
export const TableRowPlaceholder = ({text, colSpan = 2}) => {
  return (
    <TableRow>
      <TableCell style={{ textAlign: "center" }} colSpan={colSpan}>
        <Typography>{text}</Typography>
      </TableCell>
    </TableRow>
  );
}
